<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

const props = defineProps<{
    class?: HTMLAttributes['class'];
}>();
</script>

<template>
    <ul
        data-slot="sidebar-menu-sub"
        data-sidebar="menu-badge"
        :class="
            cn(
                'border-sidebar-border ml-3.5 flex min-w-0 translate-x-px flex-col gap-1 border-l py-0.5 pl-2.5',
                'group-data-[collapsible=icon]:hidden',
                props.class
            )
        "
    >
        <slot />
    </ul>
</template>
